import React from 'react';
import { Link } from 'react-router-dom';

const Header = () => {

    // Client-side navigasyonda sayfa yenilenmedigi icin acik mobil menu
    // kendiliginden kapanmiyor; her link tikaninda elle kapatiyoruz.
    // Bootstrap'in data-bs-toggle="collapse" isleyicisi document uzerinde capture
    // fazinda calisiyor ve <a> hedeflerinde preventDefault cagiriyor; bu yuzden
    // <Link> ile birlikte kullanilamiyor, navigasyonu iptal ediyor.
    const closeMobileNav = () => {
        document.getElementById('gloworksNav')?.classList.remove('show');
    };

    return (
        <header className="gloworks-header">
            <nav className="navbar navbar-expand-lg">
                <div className="container">

                    <Link className="navbar-brand me-0" to="/" onClick={closeMobileNav}>
                        <img className={'w-100'} src={'/site/assets/img/gloworks-logo.png'} alt={'logo'} />
                    </Link>

                    <button
                        className="navbar-toggler shadow-none border-0"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#gloworksNav"
                        aria-controls="gloworksNav"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="bi bi-list text-white fs-1"></i>
                    </button>

                    <div className="collapse navbar-collapse" id="gloworksNav">

                        <ul className="navbar-nav mx-auto align-items-center gap-4 py-4 py-lg-0">
                            <li className="nav-item">
                                <Link className="nav-link text-white nav-custom-link" to="/#home-method" onClick={closeMobileNav}>ABOUT US</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white nav-custom-link" to="/#home-scope-service" onClick={closeMobileNav}>WHAT WE DO</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white nav-custom-link" to="/#home-leadership" onClick={closeMobileNav}>TEAM</Link>
                            </li>
                            <li className="nav-item">
                                <Link className="nav-link text-white nav-custom-link" to="/#home-experience" onClick={closeMobileNav}>EXPERIENCE</Link>
                            </li>
                            <li className="nav-item">
                                <Link
                                    className="nav-link text-white nav-custom-link"
                                    to="/contact"
                                    onClick={closeMobileNav}
                                >
                                    CONTACT
                                </Link>
                            </li>
                        </ul>

                        <div className="d-flex justify-content-center pb-3 pb-lg-0">
                            <Link
                                to="/contact"
                                className="btn btn-talk px-4 py-2 fw-500"
                                onClick={closeMobileNav}
                            >
                                LET'S TALK <i className="bi bi-arrow-up-right btn-icon ms-2"></i>
                            </Link>
                        </div>

                    </div>

                </div>
            </nav>
        </header>
    );
};

export default Header;